/**
 * @Author: 韩祺涛
 * @Date: 2022-11-29
 * @Project: 杭氧客户现场使用
 */
/**
 * 获取第一个表格的可视化高度
 * @param {*} extraHeight 额外的高度(表格底部的内容高度 Number类型)
 * @param {*} id 当前页面中有多个table时需要制定table的id
 * @param {*} type 判断是否需要额外计算
 */
export function getTableScroll (extraHeight, id, type) {
  let tHeader = null
  if (id) {
    tHeader = document.getElementById(id) ? document.getElementById(id).getElementsByClassName('ant-table-thead')[0] : null
  } else {
    tHeader = document.getElementsByClassName('ant-table-thead')[0]
  }
  // 表格内容距离顶部的距离
  let tHeaderBottom = 0
  if (tHeader) {
    tHeaderBottom = tHeader.getBoundingClientRect().bottom
    if (type === 'subtract') {
      // 因为展开的搜索条件两行高度为80，并且收缩有300ms动画，所以点击收缩的时候要减去80
      tHeaderBottom = tHeaderBottom - 80
    }
  }
  // 窗体高度-表格内容顶部的高度-表格内容底部的高度
  // let height = document.body.clientHeight - tHeaderBottom - extraHeight
  const height = `calc(100vh - ${Math.ceil(tHeaderBottom) + extraHeight}px)`
  return height
}
